import script from "./MainOnboardProfilePhotoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOnboardProfilePhotoComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainOnboardProfilePhotoComponent.vue?vue&type=style&index=0&id=3b454892&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b454892"]])

export default __exports__